module.exports = __webpack_public_path__ + "img/logo_top.70634211.png";